<form class="filtros-header filtros-header-component" [formGroup]="form">
    <mat-form-field class="form-cliente">
    <mat-label>Cliente:</mat-label>
        <input type="text" placeholder="Cliente" matInput formControlName="clienteFormControl" [matAutocomplete]="auto" (change)="changeCallback()">
        <mat-autocomplete #auto="matAutocomplete">
            <mat-option *ngFor="let option of filteredOptions | async" (onSelectionChange)="setCliente(option)"
                [value]="option.nome">
                {{option.nome}}
            </mat-option>
        </mat-autocomplete>
    </mat-form-field>
</form>
